import { DESTINATION_TYPES } from '../../../constants';
import type { DestinationType } from '../../../types';

/** Returns whether the billing address form should be visible. */
export function shouldShowBillingAddress(destinationType: DestinationType, billingMatchesShipping: boolean): boolean {
  // Pickup points always need billing fields; regular shipping only needs them when the addresses differ.
  return destinationType === DESTINATION_TYPES.PICKUP_POINT || !billingMatchesShipping;
}
